import { Container, MetricRow } from '@/components/ui'
import CourseComboPrice, { type GiftComboInfo } from '@/components/course/CourseComboPrice'

const STATS = [
  { value: '5+', label: 'Khóa học hiện có', desc: 'Khóa học được biên soạn bởi chuyên gia' },
  { value: '1.500+', label: 'Học viên tham gia', desc: 'Đã học và thành công trong sự nghiệp BA' },
  { value: '4.8/5', label: 'Đánh giá trung bình', desc: 'Mức độ hài lòng của học viên' },
  { value: '10+', label: 'Đào tạo Doanh nghiệp', desc: 'Viettel, MB, Microtec...' },
]

const ENTERPRISES = [
  { name: 'Mobio', src: '/images/enterprise-logos/mobio.png' },
  { name: 'Viettel', src: '/images/enterprise-logos/viettel.svg' },
  { name: 'MB', src: '/images/enterprise-logos/mb.png' },
  { name: 'Microtec', src: '/images/enterprise-logos/microtec.svg' },
  { name: 'Solashi', src: '/images/enterprise-logos/solashi.svg' },
  { name: 'Ringme', src: '/images/enterprise-logos/ringme.svg' },
  { name: 'VNPT', src: '/images/enterprise-logos/vnpt.png' },
  { name: 'INCOM', src: '/images/enterprise-logos/incom.png' },
]

interface EaseStatsProps {
  giftCombos?: GiftComboInfo[]
  giftCombosLoading?: boolean
  /** Course IDs học viên đã đăng ký — dùng để đổi copy KM sang giới thiệu bạn bè */
  enrolledCourseIds?: Set<number>
}

const EaseStats = ({
  giftCombos = [],
  giftCombosLoading = false,
  enrolledCourseIds,
}: EaseStatsProps) => {
  const showOffers = giftCombosLoading || giftCombos.length > 0

  return (
    <>
      {showOffers ? (
        <section
          className="eh-section--sm pt-2"
          id="uu-dai"
          aria-label="Ưu đãi combo"
        >
          <Container>
            {giftCombosLoading ? (
              <div className="space-y-6">
                <div className="h-40 rounded-eh border border-eh-border bg-eh-mint/40 animate-pulse" />
              </div>
            ) : (
              <div className="flex flex-col gap-10 overflow-visible pt-1">
                {giftCombos.map((c) => (
                  <CourseComboPrice
                    key={`${c.sourceCourseId}-${c.giftCourseId}`}
                    combo={c}
                    variant="banner"
                    isSourceEnrolled={enrolledCourseIds?.has(c.sourceCourseId) ?? false}
                  />
                ))}
              </div>
            )}
          </Container>
        </section>
      ) : null}

      <section className="eh-section--sm" id="stats" aria-label="Thống kê M2MBA">
        <Container>
          <div className="eh-reveal mb-8 max-w-2xl md:mb-10">
            <h2 className="eh-title">Được Hàng Ngàn Học Viên Tin Tưởng</h2>
            <p className="mt-4 text-base leading-relaxed text-eh-muted">
              Trở thành một phần của cộng đồng thành công, nơi nhiều học viên đã khẳng định và nâng tầm
              sự nghiệp cùng M2MBA.
            </p>
          </div>

          <MetricRow
            items={STATS.map((stat) => ({
              value: stat.value,
              label: stat.label,
              description: stat.desc,
            }))}
          />

          <div className="eh-trust-wall eh-reveal mt-10" aria-labelledby="trust-wall-title">
            <div className="eh-trust-wall__intro">
              <p className="eh-eyebrow !mb-2 !text-eh-forest-ink">Đối tác doanh nghiệp</p>
              <h3 id="trust-wall-title" className="eh-title-sm">
                Được doanh nghiệp tin tưởng lựa chọn
              </h3>
              <p className="mt-3 max-w-2xl text-sm leading-relaxed text-eh-muted md:text-[15px]">
                Các đơn vị đã lựa chọn chương trình đào tạo M2MBA để nâng năng lực Business Analysis
                và chuyển đổi số cho đội ngũ.
              </p>
            </div>

            <div className="eh-trust-marquee">
              <div className="eh-trust-marquee__track">
                {[0, 1].map((groupIndex) => (
                  <ul
                    key={groupIndex}
                    className="eh-trust-marquee__group"
                    aria-hidden={groupIndex === 1 ? 'true' : undefined}
                  >
                    {ENTERPRISES.map((company) => (
                      <li key={`${groupIndex}-${company.name}`}>
                        <article className="eh-trust-logo">
                          <img
                            src={company.src}
                            alt={groupIndex === 0 ? `Logo ${company.name}` : ''}
                            loading="lazy"
                            decoding="async"
                          />
                          <span className="eh-trust-logo__name">{company.name}</span>
                        </article>
                      </li>
                    ))}
                  </ul>
                ))}
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  )
}

export default EaseStats
